// extracted by mini-css-extract-plugin
export default {"root":"QHDQOfa2Jl"};